// extracted by mini-css-extract-plugin
export default {"link":"LinkCard_link__1kRrY","card":"LinkCard_card__JSuvx"};